var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIris(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staker---staking-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-6",
    transform: "translate(-123.000000, -152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cosmos-logo-horizontal-dark",
    transform: "translate(124.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9999365,0 C58.9867462,0 76,17.0131586 76,37.9999365 C76,58.9867462 58.9867462,76 37.9999365,76 C17.0131586,76 0,58.9867462 0,37.9999365 C0,17.0131586 17.0131586,0 37.9999365,0 Z",
    id: "Path",
    strokeOpacity: 0.2,
    stroke: "#00F3AB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "irisnet-iris-logo",
    transform: "translate(13.000000, 13.000000)",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.575,39.3 C8.055,39.89 8.565,40.455 9.09,40.985 C12.235,44.145 16.17,46.275 20.485,47.155 L22.58,50 C15.38,49.305 8.91,45.56 4.675,39.625 L7.575,39.3 Z M45.335,39.615 C41.115,45.545 34.655,49.295 27.455,50 L28.62,47.315 C33.29,46.56 37.535,44.375 40.91,40.985 C41.21,40.68 41.515,40.355 41.82,40.015 L45.335,39.615 Z M24.865,0.2 L34.845,13.765 L46.315,12.475 L39.61,27.94 L46.455,37.275 L29.775,39.175 L25.15,49.8 L15.175,36.235 L3.705,37.525 L10.44,21.985 L3.545,12.585 L20.31,10.675 L24.865,0.2 Z M20.165,35.085 L19.94,35.205 C19.5,35.42 19.03,35.6 18.545,35.735 L18.105,35.855 L24.57,44.645 L26.865,39.365 L26.45,39.31 C24.19,39.025 22.135,37.805 20.81,35.975 L20.165,35.085 Z M24.43,26.39 L17.69,27.235 L22.905,34.45 C23.965,35.915 25.68,36.79 27.49,36.79 C27.7,36.79 27.91,36.78 28.115,36.755 L41.725,35.205 L36.305,27.81 C36.035,27.445 35.725,27.115 35.38,26.825 L35.06,26.56 L31.18,35.325 L24.43,26.39 Z M2.265,14.545 L3.985,16.895 C3,19.475 2.5,22.2 2.5,25 C2.5,27.45 2.885,29.855 3.645,32.155 L2.24,35.405 C0.755,32.13 0,28.635 0,25 C0,21.345 0.76,17.83 2.265,14.545 Z M47.77,14.62 C49.25,17.885 50,21.375 50,25 C50,28.62 49.25,32.105 47.775,35.37 L46.05,33.015 C47.01,30.46 47.5,27.765 47.5,25 C47.5,22.56 47.115,20.16 46.36,17.87 L47.77,14.62 Z M26.74,17.51 L17.915,18.45 C15.895,18.665 14.135,19.96 13.325,21.83 L7.86,34.445 L16.94,33.425 C17.39,33.375 17.83,33.27 18.255,33.115 L18.645,32.97 L13.025,25.21 L24.105,23.805 L26.74,17.51 Z M25.445,5.355 L21.785,13.765 C21.605,14.18 21.475,14.615 21.395,15.065 L21.325,15.475 L30.82,14.47 L26.49,24.815 L30.595,30.25 L33.1,24.595 L34.2,22.105 C35.025,20.24 34.79,18.065 33.58,16.425 L25.445,5.355 Z M42.155,15.55 L36.465,16.195 L36.625,16.58 C37.505,18.685 37.485,21.085 36.565,23.16 L36.12,24.16 L36.335,24.305 C36.745,24.58 37.13,24.9 37.485,25.255 L37.81,25.575 L42.155,15.55 Z M19.15,13.415 L8.275,14.655 L11.735,19.375 L11.99,19.045 C13.365,17.26 15.43,16.1 17.645,15.865 L18.73,15.75 L18.75,15.485 C18.785,14.94 18.88,14.395 19.025,13.865 L19.15,13.415 Z M27.44,0 C34.635,0.7 41.095,4.445 45.325,10.375 L42.43,10.7 C41.95,10.11 41.44,9.545 40.91,9.015 C37.77,5.86 33.84,3.73 29.535,2.85 L27.44,0 Z M22.565,0 L21.4,2.68 C16.725,3.43 12.47,5.62 9.09,9.015 C8.835,9.27 8.58,9.545 8.325,9.825 L4.78,10.23 C9.01,4.39 15.43,0.69 22.565,0 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIris);
export default __webpack_public_path__ + "static/media/iris.abdfdc035ec86595611882bc8439d89a.svg";
export { ForwardRef as ReactComponent };